import React, { useState } from "react";
import {
  AlertDialog,
  AlertDialogAction,
  AlertDialogCancel,
  AlertDialogContent,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
} from "@ui/alert-dialog";
import TranslatedTextTemp from "@components/items/display/TranslatedTextTemp";
import { Card } from "@ui/card";
import TranslatedText from "@components/items/display/TranslatedText";
import { ResourcesKey } from "@modules/localizations/translate";

const DeleteReasonsDialog = ({
  openDialog,
  setOpenDialog,
  setOpenConfirmDeleteAccountDialog,
}: {
  openDialog: boolean;
  setOpenDialog: (state: boolean) => void;
  setOpenConfirmDeleteAccountDialog: (state: boolean) => void;
}) => {
  const reasons = [
    `settings.dialogs.accountDeactivation.reasons.1`,
    `settings.dialogs.accountDeactivation.reasons.2`,
    `settings.dialogs.accountDeactivation.reasons.2`,
    `settings.dialogs.accountDeactivation.reasons.4`,
  ];
  const [selectedReason, setSelectedReason] = useState<number | null>(null);

  const onOpenChange = () => {
    setOpenDialog(false);
  };
  return (
    <AlertDialog
      open={openDialog}
      onOpenChange={(open) => {
        onOpenChange();
      }}
    >
      <AlertDialogContent className="border-none bg-white dark:bg-[#37383F]">
        <AlertDialogHeader>
          <AlertDialogTitle className="ltr:text-left rtl:text-right">
            <TranslatedTextTemp
              text={`settings.dialogs.${"delete account"}`}
              origintext="delete account"
              className="text-[20px] font-medium"
            />
          </AlertDialogTitle>
          <div className="flex flex-col items-start justify-center gap-1 pb-5 pt-2 ltr:text-left rtl:text-right">
            <TranslatedTextTemp
              text={`settings.dialogs.${"why do you want to delete your account?"}`}
              origintext="why do you want to delete your account?"
            />
          </div>
        </AlertDialogHeader>

        <div className="space-y-5 pb-5">
          {reasons.map((reason, index) => (
            <Card
              key={index}
              className={`cursor-pointer bg-[#D9D9D9]/15 p-2 text-[14px] hover:bg-[#D9D9D9]/25 dark:text-white ${
                selectedReason === index
                  ? "border border-primary dark:border-white"
                  : "border-none"
              }`}
              onClick={() => setSelectedReason(index)}
            >
              <TranslatedText text={reason as ResourcesKey} />
            </Card>
          ))}
        </div>
        <AlertDialogFooter className="gap-x-4">
          <AlertDialogAction
            className="bg-[#D9D9D9] hover:bg-[#D9D9D9] hover:opacity-85"
            disabled={!selectedReason}
            onClick={() => {
              setOpenConfirmDeleteAccountDialog(true);
              setSelectedReason(null);
            }}
          >
            <TranslatedTextTemp
              text={`settings.dialogs.${"delete account"}`}
              origintext="delete account"
              className="text-[16px] font-normal !text-[#FF5153]"
            />
          </AlertDialogAction>
          <AlertDialogCancel
            className="dark:border-none dark:hover:bg-transparent"
            onClick={() => {
              setSelectedReason(null);
            }}
          >
            <TranslatedTextTemp
              text={`settings.dialogs.${"keep my account"}`}
              origintext="keep my account"
              className="text-[16px] font-normal !text-[#FF5153]"
            />
          </AlertDialogCancel>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  );
};

export default DeleteReasonsDialog;
